var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLinkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 0.75H13.125C13.5898 0.75 14 1.16016 14 1.625V6C14 6.49219 13.5898 6.875 13.125 6.875C12.6328 6.875 12.25 6.49219 12.25 6V3.75781L6.72656 9.25391C6.39844 9.60938 5.82422 9.60938 5.49609 9.25391C5.14062 8.92578 5.14062 8.35156 5.49609 8.02344L10.9922 2.5H8.75C8.25781 2.5 7.875 2.11719 7.875 1.625C7.875 1.16016 8.25781 0.75 8.75 0.75ZM2.1875 1.625H5.25C5.71484 1.625 6.125 2.03516 6.125 2.5C6.125 2.99219 5.71484 3.375 5.25 3.375H2.1875C1.94141 3.375 1.75 3.59375 1.75 3.8125V12.5625C1.75 12.8086 1.94141 13 2.1875 13H10.9375C11.1562 13 11.375 12.8086 11.375 12.5625V9.5C11.375 9.03516 11.7578 8.625 12.25 8.625C12.7148 8.625 13.125 9.03516 13.125 9.5V12.5625C13.125 13.793 12.1406 14.75 10.9375 14.75H2.1875C0.957031 14.75 0 13.793 0 12.5625V3.8125C0 2.60938 0.957031 1.625 2.1875 1.625Z",
    fill: "#D8D8D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLinkDark);
export default __webpack_public_path__ + "static/media/edit_link_dark.7c4303a976e942a7ca8d2c178bff3733.svg";
export { ForwardRef as ReactComponent };